<template>
    <div class="overflow-x-hidden">
        <header-panel />

        <div class="px-2">
            <section class="container mx-auto bg-white rounded-lg shadow-light dark:shadow-dark p-5 sm:p-10 mt-24 mb-20 dark:bg-dark.tableBG dark:text-dark.contentText">
                <h1 class="font-bold text-xl">{{ $t('desktop_app_download') }}</h1>
                <section v-if="!loading" class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-full">
                    <slot v-for="(version, index) in cx1_versions" :key="index">
                        <div class="p-5 pb-10 bg-gray-100 rounded-lg shadow-light dark:shadow-dark m-5 text-center cursor-pointer hover:shadow-light dark:shadow-dark dark:bg-dark.panels dark:hover:bg-opacity-60 hover:bg-gray-200" 
                            @click="download(version.name, 'cxone_app')">
                            <font-awesome-icon v-if="version.os_version.substr(0,7) == 'Windows'" icon="fa-brands fa-windows" class="text-4xl my-5" />
                            <font-awesome-icon v-else icon="fa-brands fa-apple" class="text-4xl my-5" />
                            <h3 class="font-bold mb-4 capitalize">
                                {{ version.os_version }}
                            </h3>
                            <span class="font-bold" style="color:#10B981;font-size:40px;">X</span><br />
                        </div>
                    </slot>
                </section>
                <section v-else class="text-center p-10">
                    <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-2xl text-gray-400" />
                </section>
            </section>
        </div>

        <footer-panel />
    </div>
</template>

<script setup>
    import headerPanel from "@/components/landing/HeaderLanding.vue";
    import FooterPanel from "@/components/landing/FooterLanding.vue"
</script>

<script>
    export default {
        components: {FooterPanel, headerPanel},
        data() {
            return {
                menuOpen:false,
                cx1_versions: [],
                loading:false
            }
        },
        methods: {
            get_cx1_versions() {
                this.loading = true
                this.$axios.get(`githubDownload/?q=assets&app=cxone_app`).then((result) => {
                    this.cx1_versions = result.data
                }, (error) => {
                    console.log(error);
                }).finally(() => {this.loading = false});
            },
            download(file, app) {
                let baseURL = import.meta.env.VITE_API_URL;
                if (window.location.host === "creatorx.one") {
                    baseURL = import.meta.env.VITE_API_URL_NO_CLOUDFLARE;
                }
                window.open(`${baseURL}githubDownload/?q=download&file=${file}&app=${app}`)
            }
        },
        created() {
            this.get_cx1_versions()
        }
    }
</script>